import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor() { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const token = sessionStorage.getItem('tokenMotor');

    const getPayload = (request.body as any).payload

    if (!token || this.#servicesNotUpdated().some(service => request.url.includes(service))) {
      return next.handle(request);
    }

    const authReq = request.clone({
      body: {
        ...(request.body as object),
        payload: {
          ...getPayload,
          token
        },
        token: token
      }
    });

    return next.handle(authReq);
  }


  #servicesNotUpdated() {
    return [
      'loginMotorAdmin',
      'cataloge',
      's3.amazonaws.com',
      '/api/v1/',

    ]
  }
}
